export default __webpack_public_path__ + "static/media/protectedAreas.ea734ca4.kml";